import { Center } from "@mantine/core";

import AuthLayout from "../../Layouts/AuthLayout";
import AuthBranding from "./Components/AuthBranding";
import LoginCard from "./Components/LoginCard";

export default function Login() {
    return (
        <AuthLayout
            left={<AuthBranding />}
            right={
                <Center h="100%">
                    <LoginCard />
                </Center>
            }
        />
    );
}